import React from 'react';
import { LucideIcon } from 'lucide-react';

interface InfoFieldProps {
  icon: LucideIcon;
  label: string;
  value: string;
  className?: string;
}

export const InfoField: React.FC<InfoFieldProps> = ({
  icon: Icon,
  label,
  value,
  className = ""
}) => {
  return (
    <div className={`flex items-center min-w-0 ${className}`}>
      <Icon className="h-5 w-5 text-gray-400 mt-1 flex-shrink-0" />
      <div className="min-w-0 ml-4 flex-1 overflow-hidden">
        <p className="text-sm font-medium text-gray-500 mb-1">{label}</p>
        <p className="text-base font-semibold text-gray-900 break-words truncate">{value}</p>
      </div>
    </div>
  );
}; 